"use client";

import { SideNav } from "@/components/SideNav";
import { SupportPage } from "@/components/SupportPage";

export default function SupportPageClient() {
  return (
    <>
      <SideNav />
      <SupportPage />
    </>
  );
}
